import { render, staticRenderFns } from "./OrderSummaryModal.vue?vue&type=template&id=a3ef3ad2&"
import script from "./OrderSummaryModal.vue?vue&type=script&lang=ts&"
export * from "./OrderSummaryModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QForm,QCardSection,QBtnToggle,QTable,QTd,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QForm,QCardSection,QBtnToggle,QTable,QTd,QCardActions})
